//
// Helper functions for graph serialization
//

export function serializeGraph(graph) {

  let res = {
    allElementsHaveSizeAndPosition: true, // deserialize will check that flag to know if it can skip resizing boxes
    scenarioEditorVersion: 3, // increase when a change to the editor changes the size of a box (hence requiring a resize when an older scenario it is deserialized)
    elements: {}
  };
  // jointjs graph.toJSON function is badly named. The returned result is not json but a js object.
  let graphObj = graph.toJSON();
  let rawElements = graphObj.cells;
  let serializeFunctionSwitch = {
    'html.QuestionBox': serializeQuestionBox,
    'html.RootQuestionBox': serializeQuestionBox,
    'html.MessageWithChoiceBox': serializeMessageWithChoiceBox,
    'html.MessageWithoutQRBox': serializeMessageWithoutQRBox,
    'html.WaitForMessageBox': serializeWaitForMessageBox,
    'html.UserInputAnswer': serializeUserInputAnswer,
    'html.SurveyFeedbackBox': serializeSurveyFeedbackBox,
    'html.Answer': serializeAnswer,
    'html.SurveyFeedbackAnswer': serializeSurveyFeedbackAnswer,
    'html.SubBotBox': serializeSubBotBox,
    'html.SubBotExit': serializeSubBotExit,
    'html.AiConnectorBox': serializeSubBotBox,
    'html.AiConnectorExit': serializeSubBotExit,
    'html.WhatsappTemplateBox': serializeWhatsappTemplateBox,
    'html.WhatsappTemplateExit': serializeWhatsappTemplateExit,
    'html.BotConnectorBox': serializeBotConnectorBox,
    'html.FacebookProductBox': serializeFacebookProductBox,
    'html.RecurringNotifBox': serializeRecurringNotifBox,
    'html.ActionBox': serializeActionBox,
    'html.Action': serializeAction,
    'html.Next': serializeNext,
    'html.NextWhatsappWelcomeMessages': serializeNext,
    'html.NextWithDelay': serializeNext,
    'html.Then': serializeNext,
    'html.Else': serializeNext,
    'html.WhenBH': serializeNext,
    'html.WhenNBH': serializeNext,
    'html.UserInput': serializeNext,
    'html.RecurringNotifAccepted': serializeNext,
    'html.Optin': serializeNext,
    'html.NotOptin': serializeNext,
    'html.SetCustomFieldSuccess': serializeNext,
    'html.SetCustomFieldFail': serializeNext,
    'html.OtherUserInputText': serializeNext,
    'html.HandoverBox': serializeHandoverBox,
    'html.HandoverItem': serializeHandoverItem,
    'html.GetStartedBox': serializeSimpleEntrypointBox,
    'html.MenuItem': serializeMenuItem,
    'html.SurveyStartedBox': serializeSimpleEntrypointBox,
    'html.NewConversationBox': serializeSimpleEntrypointBox,
    'html.UnexpectedUserInputBox': serializeSimpleEntrypointBox,
    'html.AgentShortcutBox': serializeSimpleEntrypointBox,
    'html.MassMessagingEntryPointBox': serializeSimpleEntrypointBox,
    'html.ReceiveControlBox': serializeReceiveControlBox,
    'html.MessengerMDotMeLinkBox': serializeReceiveControlBox,
    'html.ExternalEndpointEntryPointBox': serializeReceiveControlBox,
    'html.LinkWithRefEntryPointBox': serializeReceiveControlBox,
    'html.ClickToMessengerBox': serializeFacebookAdBox,
    'html.ClickToMessengerWithAdIdsBox': serializeFacebookAdBox,
    'html.SponsoredBzcMessageBox': serializeFacebookAdBox,
    'html.FacebookAdId': serializeFacebookAdId,
    'html.MessengerCustomAppEventFromVariableBox': serializeMessengerFromVariableBox,
    'html.MessengerGenericTemplateAManoBox': serializeMessengerGenericTemplateAManoBox,
    'html.MessengerMediaTemplateAManoBox': serializeMessengerMediaOrButtonTemplateBox,
    'html.MessengerButtonTemplateAManoBox': serializeMessengerMediaOrButtonTemplateBox,
    'html.BZCRichLinkAManoBox': serializeBZCRichLinkAManoBox,
    'html.MessengerListItem': serializeMessengerListItem,
    'html.MessengerButton': serializeMessengerButton,
    'html.MessengerAddButton': serializeAddChild,
    'html.MessengerAddGlobalButton': serializeAddChild,
    'html.MessengerButtonGroupHeader': serializeMessengerButtonGroupHeader,
    'html.IfThenElseBox': serializeLogicBox,
    'html.BHNBHBox': serializeLogicBox,
    'html.EmailRequestForNotificationBox': serializeEmailRequestForNotificationBox,
    'html.PhoneRequestForNotificationBox': serializePhoneRequestForNotificationBox,
    'html.UserLanguagesBox': serializeUserLanguagesBox,
    'html.UserLanguage': serializeUserLanguage,
    'html.UserCountriesBox': serializeUserCountriesBox,
    'html.UserCountry': serializeUserCountry,
    'html.OptinNotOptinBox': serializeOptinNotOptinBox,
    'html.FirstConversationEverBox': serializeSimpleEntrypointBox,
    'html.FollowingConversationsBox': serializeSimpleEntrypointBox,
    'html.WhatsappCartSentBox': serializeSimpleEntrypointBox,
    'html.SetCustomFieldBox': serializeSetCustomFieldBox,
    'html.ConditionsOnCustomFieldsBox': serializeConditionsOnCustomFieldsBox,
    'html.ConditionsVariablesMultipleBox': serializeConditionsVariablesMultipleBox,

    'html.PromoCodeBox': serializePromoCodeBox,
    'html.PromoCodeFound': serializeNext,
    'html.NoPromoCodesAvailable': serializeNext,
    'html.UserAlreadyGotPromoCode': serializeNext,

    'html.LineRichMenuBox': serializeFacebookAdBox,
    'html.OptinCTSTitle': serializeOptinCTSTitle,

    'html.ApiConnectorBox': serializeApiConnectorBox,
    'html.ApiConnectorSuccessExit': serializeNext,
    'html.ApiConnectorFailExit': serializeNext,

    'html.NoteBox': serializeNoteBox,

    'html.AiSatisfactionBox': serializeAISatisfactionBox,
    'html.AiSatisfactionAnswerExit': serializeNext,

    'html.TextMatchBox': serializeTextMatchBox,
    'html.TextMatchAnswerExit': serializeNext,
  };
  const ROOT_ID_ELEMENT_TYPES = ['html.RootQuestionBox', 'html.GetStartedBox', 'html.SurveyStartedBox'];

  const ELEMENTS_WITH_ELEMENT_DATA = [
    'html.ListPickerAnswer',
    'html.ListPickerSection',
    'html.WhatsappMessageWithButtonsButton',
    'html.CarrouselAddButtonButton',
    'html.CarrouselButtonGroupHeader',
    'html.CarrouselElementButton',
    'html.MessageWithoutQRURLButton',
    'html.TriggerSurveyBox',
    'html.ImageCarrouselElementButton',
    'html.ImageMapAddZoneButton',
    'html.ImageMapZone',
    'html.NewCondition',
    'html.NewValueChild',
    'html.WhatsappIceBreaker',
    'html.ConfirmButton',
    'html.AiSatisfactionAnswerExit',
    'html.TextMatchAnswerExit',
  ];

  const ELEMENTS_WITH_ELEMENT_DATA_AND_CHILDREN = [
    'html.ListPickerBox',
    'html.WhatsappListMessageBox',
    'html.WhatsappMessageWithButtonsBox',
    'html.InstagramCarrouselBox',
    'html.GbmCarrouselBox',
    'html.LineCarrouselBox',
    'html.InMessageCarouselBox',
    'html.ImageCarrouselBox',
    'html.ImageMapBox',
    'html.ForkWithDelayBox',
    'html.ConditionsOnUserInputBox',
    'html.ConditionsVariablesMultipleBox',
    'html.WhatsappWelcomeMessageBox',
    'html.ConfirmBox',
    'html.OptinCTSBox',
    'html.AiSatisfactionBox',
    'html.TextMatchBox',
  ];


  for (let rawEl of rawElements) {
    if (ROOT_ID_ELEMENT_TYPES.includes(rawEl.type)) {
      res.root_id = rawEl.id;
    }
    if (serializeFunctionSwitch[rawEl.type]) {
      res.elements[rawEl.id] = serializeFunctionSwitch[rawEl.type](rawEl, graph);
    }
    if (rawEl.type === 'html.SubBotBox' || rawEl.type === 'html.AiConnectorBox') {
      addHiddenSubBotBox(res, rawEl);
    }

    if (ELEMENTS_WITH_ELEMENT_DATA.includes(rawEl.type)) {
      const type = convertHtmlTypeToBoxType(rawEl.type)
      // Call generic serializer for elements with ElementData
      res.elements[rawEl.id] = serializeElementWithElementData(rawEl, graph, type);
    }
    if (ELEMENTS_WITH_ELEMENT_DATA_AND_CHILDREN.includes(rawEl.type)) {
      const type = convertHtmlTypeToBoxType(rawEl.type)
      // Call generic serializer for elements with ElementData and children
      res.elements[rawEl.id] = serializeBoxWithElementDataAndChildren(rawEl, type);
    }
  }
  return res;
}

function convertHtmlTypeToBoxType(rawElementType) {
  // These two line are to convert 'html.ListPickerAnswer' to 'listPickerAnswer' for example
  const htmlType = rawElementType.substring(5);
  const type = htmlType.charAt(0).toLowerCase() + htmlType.slice(1);
  return type;
}

function serializeQuestionBox(box, graph) {
  let res = {
    id: box.id,
    type: 'question',
    content: box.content,
    links: box.links,
    pictureId: box.pictureId,
    videoId: box.videoId,
    fileId: box.fileId,
    fileName: box.fileName,
    user_input_answer_id: box.user_input_answer_id,
    phone_number_answer_id: box.phone_number_answer_id,
    email_answer_id: box.email_answer_id,
    can_be_deleted: box.can_be_deleted,
    disableInput: box.disableInput,
    spellCheckerLang: box.spellCheckerLang,
    position: { x: box.position.x, y: box.position.y },
    size: box.size,
    answers: box.embeds || [],
    summaryText: box.summaryText,
    maxNumberOfButtonsAllowed: box.maxNumberOfButtonsAllowed

  };
  return res;
}

function serializeMessageWithChoiceBox(box, graph) {
  let res = {
    id: box.id,
    type: 'messageWithChoiceBox',
    content: box.content,
    links: box.links,
    pictureId: box.pictureId,
    videoId: box.videoId,
    menuChoice: box.menuChoice,
    spellCheckerLang: box.spellCheckerLang,
    position: { x: box.position.x, y: box.position.y },
    size: box.size,
    answers: box.embeds || [],
  };
  return res;
}

function serializeMessageWithoutQRBox(box, graph) {
  let res = {
    id: box.id,
    type: 'messageWithoutQRBox',
    content: box.content,
    links: box.links,
    pictureId: box.pictureId,
    videoId: box.videoId,
    fileId: box.fileId,
    fileName: box.fileName,
    spellCheckerLang: box.spellCheckerLang,
    position: { x: box.position.x, y: box.position.y },
    size: box.size,
    children: box.embeds || []
  };
  return res;
}


function serializeWaitForMessageBox(box) {
  let res = {
    id: box.id,
    type: 'waitForAUserInputMessageBox',
    content: box.content,
    links: box.links,
    position: { x: box.position.x, y: box.position.y },
    size: box.size,
    children: box.embeds || [],
  };
  return res;
}

function serializeSurveyFeedbackBox(box, graph) {
  let res = {
    id: box.id,
    type: 'surveyFeedbackBox',
    elementData: box.elementData,
    position: { x: box.position.x, y: box.position.y },
    size: box.size,
    children: box.embeds || []
  };
  return res;
}

function serializeAnswer(answer, graph) {
  let res = {
    id: answer.id,
    position: answer.position,
    size: answer.size,
    type: 'answer',
    label: answer.label,
    description: answer.description,
    answerType: answer.answerType,
    hasHandover: answer.hasHandover,
    hasVerbatimMode: answer.hasVerbatimMode,
    pictureId: answer.pictureId, // TODO remove once gouvfr scenario are migrated
    pictureDataURL: answer.pictureDataURL,
    order: answer.order,
    inputListVariable: answer.inputListVariable,
    templateJinjaVariable: answer.templateJinjaVariable,
    selectedButtonIndexVariable: answer.selectedButtonIndexVariable,
    UrlButtonUrl: answer.UrlButtonUrl,
    UrlButtonUrlAndroid: answer.UrlButtonUrlAndroid,
    UrlButtonUrlIos: answer.UrlButtonUrlIos,
    UrlButtonName: answer.UrlButtonName
  };
  addSerializedLinks(graph, answer, res);
  return res;
}


function serializeUserInputAnswer(answer, graph) {
  let res = {
    id: answer.id,
    position: answer.position,
    size: answer.size,
    type: 'answer',
    label: answer.label,
    description: answer.description,
    answerType: 'user-input',
    hasHandover: answer.hasHandover,
  };
  addSerializedLinks(graph, answer, res);
  return res;
}

function serializeSurveyFeedbackAnswer(box, graph) {
  let res = {
    id: box.id,
    position: box.position,
    size: box.size,
    type: 'surveyFeedbackAnswer',
    elementData: box.elementData
  };
  addSerializedLinks(graph, box, res);
  return res;
}

function serializeSubBotBox(box, graph) {
  let res = {
    id: box.id,
    type: 'subBotBox',
    elementData: box.elementData,
    position: { x: box.position.x, y: box.position.y },
    size: box.size,
    children: box.embeds || []
  };
  return res;
}

function serializeElementWithElementData(box, graph, type) {
  const res = {
    id: box.id,
    type: type,
    position: { x: box.position.x, y: box.position.y },
    size: box.size,
    elementData: box.elementData,
  };

  if (box.type === 'html.AiSatisfactionAnswerExit') {
    /**
     * A flag used only by the BE to skip the nominal flow and prevent to redirect to the destination_id on the fly.
     */
    res.skip_sequential_flow = true;
  }
  addSerializedLinks(graph, box, res);
  return res;
}

function serializeBoxWithElementDataAndChildren(box, type) {
  const res = {
    id: box.id,
    type: type,
    elementData: box.elementData,
    position: { x: box.position.x, y: box.position.y },
    size: box.size,
    children: box.embeds || []
  };
  return res;
}

/**
 * Ads a special hidden box, only used by the backend,
 * that will also be ignored during deserialization
 */
function addHiddenSubBotBox(serializedGraph, subBotBox) {
  if (subBotBox.elementData && subBotBox.elementData.hiddenSubBotId) {
    const id = subBotBox.elementData.hiddenSubBotId;
    serializedGraph.elements[id] = {
      id,
      type: 'hiddenSubBotBox',
      elementData: {
        "subBotId": subBotBox.id
      }
    }
  }
}

function serializeSubBotExit(box, graph) {
  let res = {
    id: box.id,
    position: box.position,
    size: box.size,
    type: 'subBotExit',
    elementData: box.elementData
  };
  addSerializedLinks(graph, box, res);
  return res;
}

function serializeWhatsappTemplateBox(box, graph) {
  let res = {
    id: box.id,
    type: 'whatsappTemplateBox',
    elementData: box.elementData,
    position: { x: box.position.x, y: box.position.y },
    size: box.size,
    children: box.embeds || []
  };
  return res;
}

function serializeWhatsappTemplateExit(box, graph) {
  let res = {
    id: box.id,
    position: box.position,
    size: box.size,
    type: 'whatsappTemplateExit',
    elementData: box.elementData
  };
  addSerializedLinks(graph, box, res);
  return res;
}

function serializeBotConnectorBox(box, graph) {
  let res = {
    id: box.id,
    type: 'botConnectorBox',
    elementData: box.elementData,
    position: { x: box.position.x, y: box.position.y },
    size: box.size,
  };
  return res;
}

function serializeFacebookProductBox(box, graph) {
  const defaultElementData = {
    productId: '',
    variableName: '',
  };
  let res = {
    id: box.id,
    type: 'facebookProductBox',
    elementData: box.elementData || defaultElementData,
    position: { x: box.position.x, y: box.position.y },
    size: box.size,
    children: box.embeds || []
  };
  return res;
}

function serializeRecurringNotifBox(box, graph) {
  const defaultElementData = {
    title: '',
    optinId: null
  };
  let res = {
    id: box.id,
    type: 'recurringNotifBox',
    elementData: box.elementData || defaultElementData,
    position: { x: box.position.x, y: box.position.y },
    size: box.size,
    children: box.embeds || []
  };
  return res;
}

function serializeActionBox(actionBox, graph) {
  let res = {
    id: actionBox.id,
    type: 'actionBox',
    position: { x: actionBox.position.x, y: actionBox.position.y },
    size: actionBox.size,
    children: actionBox.embeds || []
  };
  return res;
}

function serializeAction(actionShape, graph) {
  let action = angular.copy(actionShape.action);
  action.id = actionShape.id;
  action.position = actionShape.position;
  action.size = actionShape.size;
  delete action.description;

  return action;
}

function serializeNext(next, graph) {
  let res = {
    id: next.id,
    position: next.position,
    size: next.size,
    hasVerbatimMode: next.hasVerbatimMode,
  };
  switch (next.type) {
    case 'html.Next':
      res.type = 'next';
      break;
    case 'html.NextWhatsappWelcomeMessages':
      res.type = 'nextWhatsAppWelcomeMessages';
      break;
    case 'html.NextWithDelay':
      res.type = 'nextWithDelay';
      break;
    case 'html.Then':
      res.type = 'then';
      break;
    case 'html.Else':
      res.type = 'else';
      break;
    case 'html.WhenBH':
      res.type = 'whenBH';
      break;
    case 'html.WhenNBH':
      res.type = 'whenNBH';
      break;
    case 'html.UserInput':
      res.type = 'userInput';
      break;
    case 'html.RecurringNotifAccepted':
      res.type = 'recurringNotifAccepted';
      break;
    case 'html.Optin':
      res.type = 'optin';
      break;
    case 'html.NotOptin':
      res.type = 'notOptin';
      break;
    case 'html.SetCustomFieldSuccess':
      res.type = 'setCustomFieldSuccess';
      break;
    case 'html.SetCustomFieldFail':
      res.type = 'setCustomFieldFail';
      break;
    case 'html.PromoCodeFound':
      res.type = 'promoCodeFound';
      break;
    case 'html.NoPromoCodesAvailable':
      res.type = 'noPromoCodesAvailable';
      break;
    case 'html.UserAlreadyGotPromoCode':
      res.type = 'userAlreadyGotPromoCode';
      break;
    case 'html.OtherUserInputText':
      res.type = 'otherUserInputText';
      break;
    case 'html.ApiConnectorSuccessExit':
      res.type = 'apiConnectorSuccessExit';
      break;
    case 'html.ApiConnectorFailExit':
      res.type = 'apiConnectorFailExit';
      break;
    case 'html.AiSatisfactionAnswerExit':
      res.type = 'aiSatisfactionAnswerExit';
      break;
    case 'html.TextMatchAnswerExit':
      res.type = 'textMatchAnswerExit';
      break;
    default:
      res.type = 'unknown';
      break;
  }
  addSerializedLinks(graph, next, res);
  return res;
}

function addSerializedLinks(graph, box, res) {
  let links = graph.getConnectedLinks(box, { outbound: true });
  if (links.length > 0) {
    res.destination_id = links[0].getTargetElement().id;
    res.destination_edge_data = links[0].get('vertices');
  }
  else {
    res.destination_id = null;
    res.destination_edge_data = null;
  }
}

function serializeHandoverBox(handoverBox, graph) {
  let res = serializeActionBox(handoverBox, graph);
  res.type = 'handoverBox';
  res.target_app_id = handoverBox.target_app_id;
  res.thread_control_metadata = handoverBox.thread_control_metadata;
  res.timeout = handoverBox.timeout;
  return res;
}

function serializeHandoverItem(handoverItem, graph) {
  let res = serializeNext(handoverItem, graph);
  res.type = 'handoverItem';
  res.data = handoverItem.data;
  res.handoverType = handoverItem.handoverType;
  res.description = handoverItem.description;
  return res;
}

function serializeSimpleEntrypointBox(simpleEntrypointBox, graph) {
  let res = serializeActionBox(simpleEntrypointBox, graph);
  res.entrypoint_description = simpleEntrypointBox.entrypoint_description;
  switch (simpleEntrypointBox.type) {
    case 'html.GetStartedBox':
      res.type = 'getStartedBox';
      res.greeting_message = simpleEntrypointBox.greeting_message;
      res.composer_input_disabled = simpleEntrypointBox.composer_input_disabled;
      break;
    case 'html.SurveyStartedBox':
      res.type = 'surveyStartedBox';
      break;
    case 'html.NewConversationBox':
      res.type = 'newConversationBox';
      break;
    case 'html.UnexpectedUserInputBox':
      res.type = 'unexpectedUserInputBox';
      break;
    case 'html.AgentShortcutBox':
      res.type = 'agentShortcutBox';
      break;
    case 'html.MassMessagingEntryPointBox':
      res.type = 'massMessagingEntryPointBox';
      break;
    case 'html.FirstConversationEverBox':
      res.type = 'firstConversationEverBox';
      res.greeting_message = simpleEntrypointBox.greeting_message;
      res.composer_input_disabled = simpleEntrypointBox.composer_input_disabled;
      res.delay_until_first_conversation_ever = simpleEntrypointBox.delay_until_first_conversation_ever;
      break;
    case 'html.FollowingConversationsBox':
      res.type = 'followingConversationsBox';
      break;
    case 'html.WhatsappCartSentBox':
      res.type = 'whatsappCartSentBox';
      break;
    default:
      res.type = 'unknown';
      break;
  }
  return res;
}

// Serialize persistent menu item associated with facebook get started box
function serializeMenuItem(menuItemShape, graph) {
  let res = {
    id: menuItemShape.id,
    position: menuItemShape.position,
    size: menuItemShape.size,
    type: 'menuItem',
    menuItem: menuItemShape.menuItem
  };
  addSerializedLinks(graph, menuItemShape, res);
  return res;
}

function serializeReceiveControlBox(receiveControlBox, graph) {
  let res = serializeActionBox(receiveControlBox, graph);
  res.entrypoint_description = receiveControlBox.entrypoint_description;
  switch (receiveControlBox.type) {
    case 'html.ReceiveControlBox':
      res.type = 'receiveControlBox';
      break;
    case 'html.MessengerMDotMeLinkBox':
      res.type = 'messengerMDotMeLinkBox';
      break;
    case 'html.ExternalEndpointEntryPointBox':
      res.type = 'externalEndpointEntryPointBox';
      break;
    case 'html.LinkWithRefEntryPointBox':
      res.type = 'linkWithRefEntryPointBox';
      break;
    default:
      res.type = 'unknown';
      break;
  }
  res.thread_control_metadata = receiveControlBox.thread_control_metadata;
  return res;
}

function serializeFacebookAdBox(adBox, graph) {
  let res = serializeActionBox(adBox, graph);
  switch (adBox.type) {
    case 'html.ClickToMessengerBox':
      res.type = 'clickToMessengerBox';
      break;
    case 'html.ClickToMessengerWithAdIdsBox':
      res.type = 'clickToMessengerWithAdIdsBox';
      break;
    case 'html.SponsoredBzcMessageBox':
      res.type = 'sponsoredBzcMessageBox';
      break;
    case 'html.LineRichMenuBox':
      res.type = 'lineRichMenuBox';
      break;
    default:
      res.type = 'unknown';
      break;
  }
  res.postback_payload = adBox.postback_payload;
  res.entrypoint_description = adBox.entrypoint_description;
  if (adBox.ad_id) {
    res.ad_id = adBox.ad_id;
  }
  return res;
}

function serializeFacebookAdId(box, graph) {
  let res = {
    id: box.id,
    position: box.position,
    size: box.size,
    type: 'facebookAdId',
    elementData: box.elementData
  };
  addSerializedLinks(graph, box, res);
  return res;
}

function serializeMessengerFromVariableBox(box, graph) {
  let res = serializeActionBox(box, graph);
  switch (box.type) {
    case 'html.MessengerCustomAppEventFromVariableBox':
      res.type = 'messengerCustomAppEventFromVariableBox';
      break;
    default:
      res.type = 'unknown';
      break;
  }
  res.input_variable = box.input_variable;
  res.variable_origin = box.variable_origin;
  if (box.origin_url !== undefined) {
    res.origin_url = box.origin_url;
  }
  return res;
}

function serializeMessengerGenericTemplateAManoBox(box, graph) {
  return {
    id: box.id,
    type: 'messengerGenericTemplateAManoBox',
    position: { x: box.position.x, y: box.position.y },
    size: box.size,
    elements: box.elements,
    buttonsAndHeaders: box.embeds || []
  };
}


function serializeMessengerMediaOrButtonTemplateBox(box, graph) {
  let type = 'unknown';
  switch (box.type) {
    case 'html.MessengerMediaTemplateAManoBox':
      type = 'messengerMediaTemplateAManoBox';
      break;
    case 'html.MessengerButtonTemplateAManoBox':
      type = 'messengerButtonTemplateAManoBox';
      break;
  }
  return {
    id: box.id,
    type: type,
    position: { x: box.position.x, y: box.position.y },
    size: box.size,
    element: box.element,
    buttonsAndHeaders: box.embeds || []
  };
}

function serializeBZCRichLinkAManoBox(handoverBox, graph) {
  let res = serializeActionBox(handoverBox, graph);
  res.type = 'BZCRichLinkAManoBox';
  res.rich_link = handoverBox.rich_link;
  return res;
}

function serializeMessengerListItem(item, graph) {
  let res = serializeNext(item, graph);
  res.type = 'messengerListItem';
  res.item = item.item;
  return res;
}

function serializeMessengerButton(button, graph) {
  let res = serializeNext(button, graph);
  res.type = 'messengerButton';
  res.carouselElementId = button.carouselElementId;
  res.button = button.button;
  return res;
}

function serializeAddChild(box, graph) {
  let type = 'unknown';
  switch (box.type) {
    case 'html.MessengerAddButton':
      type = 'messengerAddButton';
      break;
    case 'html.MessengerAddGlobalButton':
      type = 'messengerAddGlobalButton';
      break;
  }
  return {
    id: box.id,
    position: box.position,
    size: box.size,
    type: type,
    addChildId: box.addChildId,
  };
}

function serializeMessengerButtonGroupHeader(box, graph) {
  return {
    id: box.id,
    position: box.position,
    size: box.size,
    type: 'messengerButtonGroupHeader',
    carouselElementId: box.carouselElementId,
  };
}

function serializeLogicBox(box, graph) {
  let res = serializeActionBox(box, graph);
  switch (box.type) {
    case 'html.IfThenElseBox':
      res.type = 'ifThenElseBox';
      break;
    case 'html.BHNBHBox':
      res.type = 'BHNBHBox';
      break;
    default:
      res.type = 'unknown';
      break;
  }
  if (box.expression) {
    res.expression = box.expression;
  }
  return res;
}

function serializeEmailRequestForNotificationBox(box, graph) {
  let res = {
    id: box.id,
    type: 'EmailRequestForNotificationBox',
    content: box.content,
    links: box.links,
    pictureId: box.pictureId,
    videoId: box.videoId,
    emailSender: box.emailSender,
    emailSubject: box.emailSubject,
    emailContent: box.emailContent,
    emailLinks: box.emailLinks,
    landingPageUrl: box.landingPageUrl,
    position: { x: box.position.x, y: box.position.y },
    size: box.size,
    answers: box.embeds || [],
    email_answer_id: box.email_answer_id
  };
  return res;
}

function serializePhoneRequestForNotificationBox(box, graph) {
  let res = {
    id: box.id,
    type: 'PhoneRequestForNotificationBox',
    content: box.content,
    links: box.links,
    pictureId: box.pictureId,
    videoId: box.videoId,
    smsContent: box.smsContent,
    smsLinks: box.smsLinks,
    landingPageUrl: box.landingPageUrl,
    position: { x: box.position.x, y: box.position.y },
    size: box.size,
    answers: box.embeds || [],
    phone_number_answer_id: box.phone_number_answer_id
  };
  return res;
}

function serializeUserLanguagesBox(box, graph) {
  return {
    id: box.id,
    type: 'userLanguagesBox',
    position: { x: box.position.x, y: box.position.y },
    size: box.size,
    children: box.embeds || []
  };
}

function serializeUserLanguage(language, graph) {
  let res = {
    id: language.id,
    type: 'userLanguage',
    position: language.position,
    size: language.size,
    elementData: language.elementData
  };
  addSerializedLinks(graph, language, res);
  return res;
}

function serializeUserCountriesBox(box, graph) {
  return {
    id: box.id,
    type: 'userCountriesBox',
    position: { x: box.position.x, y: box.position.y },
    size: box.size,
    children: box.embeds || []
  };
}

function serializeUserCountry(item, graph) {
  let res = {
    id: item.id,
    type: 'userCountry',
    position: item.position,
    size: item.size,
    elementData: item.elementData
  };
  addSerializedLinks(graph, item, res);
  return res;
}

function serializeOptinNotOptinBox(box, graph) {
  let res = {
    id: box.id,
    type: 'optinNotOptinBox',
    position: { x: box.position.x, y: box.position.y },
    size: box.size,
    children: box.embeds || [],
    elementData: box.elementData
  };
  return res;
}

function serializeSetCustomFieldBox(box, graph) {
  let res = {
    id: box.id,
    type: 'setCustomFieldBox',
    position: { x: box.position.x, y: box.position.y },
    size: box.size,
    children: box.embeds || [],
    elementData: box.elementData
  };
  return res;
}

function serializeConditionsOnCustomFieldsBox(box, graph) {
  let res = {
    id: box.id,
    type: 'customFieldsConditionsBox',
    position: { x: box.position.x, y: box.position.y },
    size: box.size,
    children: box.embeds || [],
    elementData: box.elementData
  };
  return res;
}

function serializeConditionsVariablesMultipleBox(box, graph) {
  let res = {
    id: box.id,
    type: 'conditionsVariablesMultipleBox',
    position: { x: box.position.x, y: box.position.y },
    size: box.size,
    children: box.embeds || [],
    elementData: box.elementData
  };
  return res;
}

function serializePromoCodeBox(box) {
  let res = {
    id: box.id,
    type: 'promoCodeBox',
    position: { x: box.position.x, y: box.position.y },
    size: box.size,
    children: box.embeds || [],
    elementData: box.elementData
  };
  return res;
}

function serializeOptinCTSTitle(box, graph) {
  let res = {
    id: box.id,
    type: 'optinCTSTitle',
    position: { x: box.position.x, y: box.position.y },
    size: box.size,
    children: box.embeds || [],
    elementData: box.elementData,
  };
  addSerializedLinks(graph, box, res);
  return res;
}

function serializeApiConnectorBox(box) {
  let res = {
    id: box.id,
    type: 'apiConnectorBox',
    position: { x: box.position.x, y: box.position.y },
    size: box.size,
    children: box.embeds || [],
    elementData: box.elementData
  };
  return res;
}

function serializeNoteBox(box) {
  let res = {
    id: box.id,
    type: 'noteBox',
    position: { x: box.position.x, y: box.position.y },
    size: { ...box.size, width: 250 }, // Some boxes were saved with 200px.
    children: box.embeds || [],
    elementData: box.elementData
  };
  return res;
}

function serializeAISatisfactionBox(box) {
  let res = {
    id: box.id,
    type: 'aiSatisfactionBox',
    position: { x: box.position.x, y: box.position.y },
    size: box.size,
    children: box.embeds || [],
    elementData: box.elementData
  };
  return res;
}

function serializeTextMatchBox(box) {
  let res = {
    id: box.id,
    type: 'textMatchBox',
    position: { x: box.position.x, y: box.position.y },
    size: box.size,
    children: box.embeds || [],
    elementData: box.elementData
  };
  return res;
}